import {useProductListView} from '@/_application/modules/products/provider/product-list-view.provider';
import {SortEnum, SortFields} from '__generated__/__types__';
import {useTranslation} from 'next-i18next';
import {SortInput, useProductsFilterActions} from '@/_application/modules/products/hooks/use-product-filter-actions';
import {useMemo, useTransition} from 'react';

interface SortingTabProps {
    sortFields: SortFields;
    onConfirm: () => void;
}
const SortingTab: React.FC<SortingTabProps> = ({sortFields, onConfirm}) => {
    const {t} = useTranslation();
    const {sort} = useProductListView();
    const {handleSortChange: handleFilterSortChange} = useProductsFilterActions();
    const [, startTransition] = useTransition();
    const handleSortChange = ({sortKey, direction}: SortInput) => {
        onConfirm();
        startTransition(() => {
            handleFilterSortChange({sortKey, direction});
        });
    };

    const renderSortFieldsItem = useMemo(() => {
        return sortFields?.options?.map(option => {
            const optionValue = option?.value as string;
            const direction = (sort && (sort as {[p: string]: SortEnum})[optionValue]) ?? SortEnum.Asc;
            return (
                <>
                    <li key={`${option?.value}-${SortEnum.Asc}`} className="my-5">
                        <label className="item-between flex justify-between">
                            <span className="text-sm font-bold">{`${t(option?.label ?? '')} ${
                                option?.value === 'price' ? t('text-ascending') : ''
                            }`}</span>
                            <input
                                type="radio"
                                id={option?.value ?? 'id-sort'}
                                name="sorting"
                                value={option?.value ?? ''}
                                checked={Object.keys(sort ?? {}).includes(optionValue) && direction === SortEnum.Asc}
                                onClick={() => handleSortChange({sortKey: optionValue, direction: SortEnum.Asc})}
                                aria-label="{`Sort by ${option?.label} Ascending`}"
                            />
                        </label>
                    </li>
                    {optionValue === 'price' && (
                        <li key={`${option?.value}-${SortEnum.Desc}`} className="my-5">
                            <label className="item-between flex justify-between">
                                <span className="text-sm font-bold"> {`${option?.label} ${t('text-descending')}`}</span>
                                <input
                                    type="radio"
                                    id={option?.value ?? 'id-sort'}
                                    name="sorting"
                                    value={option?.value ?? ''}
                                    checked={
                                        Object.keys(sort ?? {}).includes(optionValue) && direction === SortEnum.Desc
                                    }
                                    onClick={() => handleSortChange({sortKey: optionValue, direction: SortEnum.Desc})}
                                    aria-label="{`Sort by ${option?.label} Descending`}"
                                />
                            </label>
                        </li>
                    )}
                </>
            );
        });
    }, [JSON.stringify(sortFields?.options)]);

    return (
        <div className="min-h-[250px] w-full">
            <div className="mx-4 pb-10 pt-3">
                <p className="mb-3 text-center text-xl font-bold text-KPZ_Blue-Dark">{t('text-sort-by')}</p>
                <div className="h-px w-full bg-KPZ_divider"></div>
                <ul className="w-full list-none">{renderSortFieldsItem}</ul>
            </div>
        </div>
    );
};

export default SortingTab;
